import addError from '../../../utils/error.jsx';

export function request(customerId) {
    return {
        type: 'CUSTOMERS_CURRENCY_VALIDATION_REQUEST',
        customerId
    };
}

export function error(customerId, errors) {
    addError(Object.keys(errors).map(key => errors[key]));

    return {
        type: 'CUSTOMERS_CURRENCY_VALIDATION_ERROR',
        customerId,
        errors
    };
}

export function finish(customerId, validation) {
    return {
        type: 'CUSTOMERS_CURRENCY_VALIDATION_FINISH',
        customerId,
        validation
    };
}
